/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { array, string, number } from 'prop-types';
import { useUIDSeed } from 'react-uid';
import Slider from 'react-slick';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    verticalContainer: {
        position: 'relative',
        maxWidth: '1400px',
        margin: '20px 0px 0px',
        '& .slick-list': {
            overflow: 'hidden',
            width: '90%',
            margin: '0 auto',
            '@media only screen and (min-width: 1280px)': {
                minHeight: '480px',
            },
            '@media only screen and (min-width: 1024px) and (max-width: 1280px)': {
                height: '370px !important',
            },
        },
        '& .slick-slide': {
            display: 'inline-block',
            verticalAlign: 'middle',
            overflow: 'hidden',
        },
        '& .slick-current': {
            paddingRight: 0,
        },
        '& .slick-prev, & .slick-next': {
            transform: 'rotate(90deg)',
            cursor: 'pointer',
            border: 'none',
            outline: 0,
            fontSize: 0,
            lineHeight: 0,
            width: 30,
            height: 25,
            position: 'absolute',
        },
        '& .slick-prev': {
            top: '-30px',
            left: '35%',
            opacity: '0.9',
            zIndex: '1',
            width: '40px',
            height: '40px',
        },
        '& .slick-next': {
            bottom: '12%',
            right: '30%',
            opacity: '0.9',
            width: '40px',
            height: '40px',
            '@media only screen and (min-width: 1024px) and (max-width: 1280px)': {
                top: '95%',
                bottom: '0',
            },

        },
        '& .slick-disabled': {
            fill: theme.palette.cms?.disabledArrow || '#D5D5D5',
        },

    },
    carouselContainer: {
        position: 'relative',
        width: '100%',
        overflow: 'hidden',
        '& .slick-list': {
            overflow: 'hidden',
            width: '92%',
            margin: '0 auto',
        },
        '& .slick-track': {
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            overflow: 'hidden',
        },
        '& .slick-slide': {
            display: 'inline-block',
            verticalAlign: 'middle',
            overflow: 'hidden',
            padding: '0 5px',
        },
        '& .slick-prev, & .slick-next': {
            cursor: 'pointer',
            border: 'none',
            outline: 0,
            fontSize: 0,
            lineHeight: 0,
            width: 30,
            height: 25,
            position: 'absolute',
        },
        '& .slick-prev': {
            top: '16px',
            left: '-10px',
            opacity: '0.9',
            zIndex: '1',
            width: '40px',
            height: '40px',
        },
        '& .slick-next': {
            bottom: '35%',
            right: '-15px',
            opacity: '0.9',
            width: '40px',
            height: '40px',
        },
        '& .slick-disabled': {
            cursor: 'not-allowed',
            opacity: '0.5',
        },
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        maxWidth: '110px',
        margin: '0px 10px 10px 0px',
        '@media only screen and (max-width: 1024px) ': {
            maxWidth: '100%',
            margin: '0px',
        },
        '& .altImageButton': {
            marginBottom: '1rem',
        },
    },
    wrapper: {
        '& .slick-list': {
            width: '100%',

        },
    },
}));

const GraphqlPDPAltImageSliderV2 = ({
    data, style, itemsPerSlide, itemsToShow,
}) => {
    const classes = useStyles();
    const sliderRef = useRef();
    const seed = useUIDSeed();
    useEffect(() => {
        if (sliderRef?.current) {
            sliderRef.current.slickGoTo(0);
        }
    }, [data]);
    const isDesktop = useMediaQuery('(min-width: 1024.5px)');
    return (
        <div className={classes.flexCenter} key={seed(data)} data-testId="pdp_slider">
            <Slider
                dots={false}
                speed={500}
                infinite={false}
                slidesToShow={itemsToShow}
                slidesToScroll={itemsPerSlide}
                ref={sliderRef}
                vertical={!!isDesktop}
                verticalSwiping={!!isDesktop}
                nextArrow={<ChevronRightIcon />}
                prevArrow={<ChevronLeftIcon />}
                variableWidth={!data.length > 2}
                className={`carousel-container ${isDesktop ? classes.verticalContainer : classes.carouselContainer} ${style} ${data.length < 5 ? classes.wrapper : ''}`}
            >
                {data.map((item) => (
                    <div key={seed(item)}>
                        { item }
                    </div>
                ))}
            </Slider>
        </div>
    );
};
GraphqlPDPAltImageSliderV2.propTypes = {
    data: array,
    style: string,
    itemsToShow: number,
    itemsPerSlide: number,
};
GraphqlPDPAltImageSliderV2.defaultProps = {
    data: [],
    style: '',
    itemsToShow: 4,
    itemsPerSlide: 4,
};
export default GraphqlPDPAltImageSliderV2;
